import apiClient from '../services/apiClient'

export const getAllUser = async () => {
    return (await apiClient.get('/users', { params: { role: 'ROLE_ADMIN' } })).data
}

export const resetPassword = async (pseudo: string) => {
    return await apiClient.post('/users/reset-password', { pseudo }, { params: { role: 'ROLE_ADMIN' } })
}
